import script from "./title1.vue?vue&type=script&setup=true&lang=ts"
export * from "./title1.vue?vue&type=script&setup=true&lang=ts"

import "./title1.vue?vue&type=style&index=0&id=4b148b1b&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b148b1b"]])

export default __exports__